import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, CheckCircle, FastForward, Smartphone } from 'lucide-react';
export function ValueProp() {
  const benefits = [{
    icon: <MessageSquare size={24} data-id="element-174" />,
    title: 'Atención clara',
    text: 'Te explicamos la situación y las opciones disponibles de forma simple.'
  }, {
    icon: <CheckCircle size={24} data-id="element-175" />,
    title: 'Enfoque en solución',
    text: 'La atención se centra en resolver el problema dental del paciente con criterio.'
  }, {
    icon: <FastForward size={24} data-id="element-176" />,
    title: 'Sin vueltas innecesarias',
    text: 'Orientación directa, evitando pasos que no aporten al tratamiento.'
  }, {
    icon: <Smartphone size={24} data-id="element-177" />,
    title: 'Contacto por WhatsApp',
    text: 'Puedes consultar y solicitar información de forma rápida y sencilla.'
  }];
  return <section className="bg-brand-dark py-20 text-white lg:py-28" data-id="element-178">
      <div className="container mx-auto px-4 md:px-6" data-id="element-179">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-181">
            <h2 className="mb-6 text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-182">
              Tratamientos dentales directos, bien explicados y sin rodeos
            </h2>
            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-183">
              La consulta está enfocada en entregar una atención clara y
              práctica, evitando exámenes o procedimientos que no aporten a
              resolver el problema del paciente. La idea es orientar bien,
              explicar las opciones y avanzar con criterio profesional.
            </p>
          </motion.div>

          <div className="grid gap-6 sm:grid-cols-2" data-id="element-184">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="rounded-2xl bg-white/10 p-6 backdrop-blur-sm border border-white/10" data-id="element-185">
                <div className="mb-4 inline-flex rounded-lg bg-brand-accent/20 p-3 text-brand-accent" data-id="element-186">
                  {benefit.icon}
                </div>
                <h3 className="mb-2 text-lg font-semibold" data-id="element-187">{benefit.title}</h3>
                <p className="text-sm text-slate-300" data-id="element-188">{benefit.text}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}